import React, { useEffect, useRef } from "react";
import { Grid } from "@mui/material";
import { AutocompleteInput, BooleanInput, ReferenceInput, SelectInput } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";
import { administrationRequests } from "api/administrationApi";
import { googleRequests } from "api/googleApi";

const ExamRoomInput = () => {
  const { setValue } = useFormContext();
  const isOnline = useWatch({ name: "isOnline" });

  // Only one of the two room fields applies at a time, so the inactive one is null
  const previousIsOnline = useRef(isOnline);
  useEffect(() => {
    const flipped = previousIsOnline.current !== isOnline;
    previousIsOnline.current = isOnline;

    if (!isOnline) {
      setValue("googleCourseRefId", null, { shouldDirty: false });
    } else if (flipped) {
      setValue("roomId", null, { shouldDirty: false });
    }
  }, [isOnline, setValue]);

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={3}
      >
        <BooleanInput
          source="isOnline"
          label="Google зала?"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        {isOnline ? (
          <ReferenceInput
            source="googleCourseRefId"
            reference={googleRequests.getGoogleRoomsSelect()}
          >
            <SelectInput
              optionText="name"
              label="Google зала"
              fullWidth
            />
          </ReferenceInput>
        ) : (
          <ReferenceInput
            source="roomId"
            reference={administrationRequests.getRoomsSelect()}
          >
            <AutocompleteInput
              label="Зала"
              optionValue="id"
              optionText={rec =>
                `${rec.roomName} - ${rec.buildingName}${rec.capacityExam ? ` (${rec.capacityExam})` : ""}`
              }
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
              fullWidth
            />
          </ReferenceInput>
        )}
      </Grid>
    </Grid>
  );
};

export default ExamRoomInput;
